import React, { useState } from 'react';

import { OfferOption, SelectedOffer } from '../../utils/backend-api/subscribe';
import SubscriptionForm from '../SubscriptionForm';
import ChoosePlanHeader from './ChoosePlanHeader';
import CorporateInquiry from './CorporateInquiry';
import MultipleOffers from './MultipleOffers';
import SingleOffer from './SingleOffer';

interface SubscribeProps {
  defaultSelectedOffer: SelectedOffer;
  dob: string;
  isUserCBPT?: boolean;
  offers: OfferOption[];
  stripeCustomerId?: string;
  userEmail?: string;
  userFullName?: string;
  userNextBillingDate?: string;
}

const Subscribe = ({
  defaultSelectedOffer,
  dob,
  isUserCBPT,
  offers,
  stripeCustomerId,
  userFullName,
  userEmail,
  userNextBillingDate,
}: SubscribeProps) => {
  const [selectedOffer, setSelectedOffer] = useState(defaultSelectedOffer);
  const isSingleOffer = offers.length === 1;

  return (
    <div className="tw-w-full md:tw-w-10/12 lg:tw-w-9/12 tw-mx-auto tw-mt-40 tw-px-12">
      {!isSingleOffer && <ChoosePlanHeader />}
      <div className="tw-grid-cols-1 tw-grid sm:tw-grid-cols-2 tw-gap-16 sm:tw-gap-32">
        {isSingleOffer ? (
          <SingleOffer offer={offers[0]} selectedOffer={selectedOffer} />
        ) : (
          <MultipleOffers
            offers={offers}
            selectedOffer={selectedOffer}
            setSelectedOffer={setSelectedOffer}
          />
        )}
        <SubscriptionForm
          buttonText="Subscribe"
          dob={dob}
          isUserCBPT={isUserCBPT}
          selectedOffer={selectedOffer}
          stripeCustomerId={stripeCustomerId}
          userEmail={userEmail}
          userFullName={userFullName}
          userNextBillingDate={userNextBillingDate}
        />
      </div>
      <CorporateInquiry />
    </div>
  );
};

export default Subscribe;
